import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 财务
export default {
    path: '/finance',
    component: Layout,
    redirect: '/finance/checkDesign',
    alwaysShow: true,
    meta: {
        title: '财务',
        icon: 'menu_cw',
        modules: [14000]
    },
    children: [
        {
            path: 'checkDesign',
            name: 'CheckDesign',
            component: () => import('@/views/finance/checkDesign/index'),
            meta: {
                title: '待查方案',
                icon: 'spot',
                modules: [14008]
            }
        },
        //  合同跟进
        {
            path: 'follow',
            name: 'Follow',
            redirect: '/finance/offOutsourceContractFollow',
            component: routerView,
            meta: {
                title: '合同跟进',
                icon: 'spot',
                modules: [14100]
            },
            children: [
                // 线下销售合同跟进
                {
                    path: '/finance/offlineSalesFollow',
                    name: 'OfflineSalesFollow',
                    redirect: '/finance/offlineSalesFollow/index',
                    component: routerView,
                    meta: {
                        title: '线下销售合同跟进',
                        modules: [14009]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'OfflineSalesFollowList',
                            component: () => import('@/views/finance/follow/salesContractFollow/offline'),
                            meta: {
                                breadcrumb: false,
                                title: '线下销售合同跟进',
                                keepAlive: true,
                                modules: [14009]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'OfflineSalesFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/salesContractFollow/salesContractDetail'),
                            meta: {
                                title: '销售合同跟进详情',
                                activeMenu: '/finance/offlineSalesFollow/index',
                                keepAlive: true,
                                modules: [14009],
                                isDetail: true
                            }
                        },
                        {
                            path: 'change/:id',
                            name: 'OfflineChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/finance/offlineSalesFollow/index',
                                modules: [14009],
                                isDetail: true
                            }
                        },
                        {
                            path: 'history/:id',
                            name: 'OfflineSalesHistory',
                            hidden: true,
                            component: () => import('@/views/finance/follow/salesContractFollow/historyContractDetail'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/finance/offlineSalesFollow/index',
                                modules: [14009]
                            }
                        }
                    ]
                },
                // 线上销售合同跟进
                {
                    path: '/finance/onlineSalesFollow',
                    name: 'OnlineSalesFollow',
                    redirect: '/finance/onlineSalesFollow/index',
                    component: routerView,
                    meta: {
                        title: '线上销售合同跟进',
                        modules: [14009]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'OnlineSalesFollowList',
                            component: () => import('@/views/finance/follow/salesContractFollow/online'),
                            meta: {
                                breadcrumb: false,
                                title: '线上销售合同跟进',
                                keepAlive: true,
                                modules: [14009]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'OnlineSalesFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/salesContractFollow/onlineSalesContractDetail'),
                            meta: {
                                title: '销售合同跟进详情',
                                activeMenu: '/finance/onlineSalesFollow/index',
                                keepAlive: true,
                                modules: [14009],
                                isDetail: true
                            }
                        },
                        {
                            path: 'change/:id',
                            name: 'OnlineChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/finance/onlineSalesFollow/index',
                                modules: [14009],
                                isDetail: true
                            }
                        },
                        {
                            path: 'history/:id',
                            name: 'OnlineSalesHistory',
                            hidden: true,
                            component: () => import('@/views/finance/follow/salesContractFollow/onlineHistoryContractDetail'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/finance/onlineSalesFollow/index',
                                modules: [14009]
                            }
                        }
                    ]
                },
                //  资源合同跟进
                {
                    path: '/finance/resourceContractFollow',
                    name: 'ResourceContractFollow',
                    redirect: '/finance/resourceContractFollow/index',
                    component: routerView,
                    meta: {
                        title: '资源合同跟进',
                        modules: [14001]
                    },
                    children: [
                        //  资源合同跟进
                        {
                            path: 'index',
                            name: 'ResourceContractFollowList',
                            component: () => import('@/views/finance/follow/resourceContractFollow/index'),
                            meta: {
                                breadcrumb: false,
                                title: '资源合同跟进',
                                keepAlive: true,
                                modules: [14001]
                            }
                        },
                        //  资源合同跟进--详情
                        {
                            path: 'resourceContractDetail/:id',
                            name: 'ResourceFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/resourceContractFollow/resourceContractDetail'),
                            meta: {
                                title: '资源合同跟进详情',
                                activeMenu: '/finance/resourceContractFollow/index',
                                keepAlive: true,
                                modules: [14001],
                                isDetail: true
                            }
                        }
                    ]
                },
                //  线下外采合同跟进
                {
                    path: '/finance/offOutsourceContractFollow',
                    name: 'OffOutsourceContractFollow',
                    redirect: '/finance/offOutsourceContractFollow/index',
                    component: routerView,
                    meta: {
                        title: '线下外采合同跟进',
                        modules: [14011]
                    },
                    children: [
                        //  线下外采合同跟进
                        {
                            path: 'index',
                            name: 'OffOutsourceContractFollowList',
                            component: () => import('@/views/finance/follow/offOutsourceContractFollow/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线下外采合同跟进',
                                keepAlive: true,
                                modules: [14011]
                            }
                        },
                        //  线下外采合同跟进--详情
                        {
                            path: 'detail/:id',
                            name: 'OffOutsourceContractFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/offOutsourceContractFollow/contractDetail'),
                            meta: {
                                title: '线下外采合同跟进详情',
                                activeMenu: '/finance/offOutsourceContractFollow/index',
                                keepAlive: true,
                                modules: [14011],
                                isDetail: true
                            }
                        },
                        {
                            path: 'change/:id',
                            name: 'OffOutsourceContractFollowChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/finance/offOutsourceContractFollow/index',
                                modules: [13009],
                                isDetail: true
                            }
                        },
                        {
                            path: 'history/:id',
                            name: 'OffOutsourceContractFollowHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractHistory'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/finance/offOutsourceContractFollow/index',
                                modules: [13004]
                            }
                        }
                    ]
                },
                //  线上外采合同跟进
                {
                    path: '/finance/onOutsourceContractFollow',
                    name: 'OnOutsourceContractFollow',
                    redirect: '/finance/onOutsourceContractFollow/index',
                    component: routerView,
                    meta: {
                        title: '线上外采合同跟进',
                        modules: [14013]
                    },
                    children: [
                        //  线上外采合同跟进
                        {
                            path: 'index',
                            name: 'OnOutsourceContractFollowList',
                            component: () => import('@/views/finance/follow/onOutsourceContractFollow/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线上外采合同跟进',
                                keepAlive: true,
                                modules: [14013]
                            }
                        },
                        //  线上外采合同跟进--详情
                        {
                            path: 'detail/:id',
                            name: 'OnOutsourceContractFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/onOutsourceContractFollow/contractDetail'),
                            meta: {
                                title: '线上外采合同跟进详情',
                                activeMenu: '/finance/onOutsourceContractFollow/index',
                                keepAlive: true,
                                modules: [14013],
                                isDetail: true
                            }
                        },
                        {
                            path: 'change/:id',
                            name: 'OnOutsourceContractFollowChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/finance/onOutsourceContractFollow/index',
                                modules: [14013],
                                isDetail: true
                            }
                        },
                        {
                            path: 'history/:id',
                            name: 'OnOutsourceContractFollowHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractHistory'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/finance/onOutsourceContractFollow/index',
                                modules: [14013]
                            }
                        }
                    ]
                },
                // 通用合同跟进
                {
                    path: '/finance/generalContractFollow',
                    redirect: '/finance/generalContractFollow/index',
                    component: routerView,
                    meta: {
                        title: '通用合同跟进',
                        modules: [14016]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'GeneralContractFollow',
                            component: () => import('@/views/finance/follow/generalContractFollow/index'),
                            meta: {
                                breadcrumb: false,
                                title: '通用合同跟进',
                                activeMenu: '/finance/generalContractFollow/index',
                                keepAlive: true,
                                modules: [14016]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'GeneralContractFollowDetail',
                            hidden: true,
                            component: () => import('@/views/finance/follow/generalContractFollow/generalDetail'),
                            meta: {
                                title: '通用合同跟进详情',
                                activeMenu: '/finance/generalContractFollow/index',
                                modules: [14016],
                                isDetail: true
                            }
                        }
                    ]
                }
            ]
        },
        // 发票管理
        {
            path: 'invoiceManage',
            name: 'InvoiceManage',
            redirect: '/finance/invoiceManage/index',
            component: routerView,
            meta: {
                title: '发票管理',
                icon: 'spot',
                keepAlive: true,
                modules: [14012]
            },
            children: [
                //  发票列表
                {
                    path: 'index',
                    name: 'InvoiceManageList',
                    component: () => import('@/views/finance/invoiceManage/index'),
                    meta: {
                        breadcrumb: false,
                        title: '发票管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [14012]
                    }
                },
                {
                    path: 'detail/:tab/:id',
                    name: 'InvoiceManageDetail',
                    hidden: true,
                    component: () => import('@/views/finance/invoiceManage/detail'),
                    meta: {
                        title: '发票管理详情',
                        activeMenu: '/finance/invoiceManage/index',
                        keepAlive: true,
                        modules: [14012],
                        isDetail: true
                    }
                }

            ]
        },
        {
            path: 'txBusiness',
            redirect: '/finance/txBusiness/inquireManage',
            component: routerView,
            alwaysShow: true,
            meta: {
                title: '线上业务',
                icon: 'spot',
                modules: [14110]
            },
            children: [
                // 查款单
                {
                    path: 'inquireManage',
                    redirect: '/finance/txBusiness/inquireManage/index',
                    component: routerView,
                    meta: {
                        title: '查款管理',
                        modules: [14111]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'InquireManageList',
                            component: () => import('@/views/finance/txBusiness/inquireManage/index'),
                            meta: {
                                breadcrumb: false,
                                title: '查款管理',
                                keepAlive: true,
                                modules: [14111]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'InquireManageDetail',
                            component: () => import('@/views/finance/txBusiness/inquireManage/detail'),
                            hidden: true,
                            meta: {
                                title: '详情',
                                activeMenu: '/finance/txBusiness/inquireManage/index',
                                modules: [14111],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'chargeManage',
                    redirect: '/finance/txBusiness/chargeManage/index',
                    component: routerView,
                    meta: {
                        title: '充值管理',
                        modules: [14112]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ChargeManageIndex',
                            component: () => import('@/views/finance/txBusiness/chargeManage/index'),
                            meta: {
                                breadcrumb: false,
                                title: '充值管理',
                                keepAlive: true,
                                modules: [14112]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'ChargeManageDetail',
                            component: () => import('@/views/finance/txBusiness/chargeManage/detail'),
                            props: true,
                            hidden: true,
                            meta: {
                                title: '充值详情',
                                activeMenu: '/finance/txBusiness/chargeManage/index',
                                modules: [14112],
                                isDetail: true
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'channelService',
            redirect: '/finance/channelService/recharge',
            component: routerView,
            alwaysShow: true,
            meta: {
                title: '渠道服务',
                icon: 'spot',
                modules: [14120]
            },
            children: [
                {
                    path: 'recharge',
                    redirect: '/finance/channelService/recharge/index',
                    component: routerView,
                    meta: {
                        title: '渠道充值',
                        modules: [14121]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'RechargeIndex',
                            component: () => import('@/views/finance/channelService/recharge/index'),
                            props: {
                                type: 1
                            },
                            meta: {
                                breadcrumb: false,
                                title: '渠道充值',
                                keepAlive: true,
                                modules: [14121]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'RechargeDetail',
                            component: () => import('@/views/finance/channelService/recharge/detail'),
                            props: {
                                type: 1
                            },
                            hidden: true,
                            meta: {
                                title: '充值记录',
                                activeMenu: '/finance/channelService/recharge/index',
                                modules: [14121],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'deduct',
                    redirect: '/finance/channelService/deduct/index',
                    component: routerView,
                    meta: {
                        title: '渠道扣款',
                        modules: [14122]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'DeductIndex',
                            component: () => import('@/views/finance/channelService/deduct/index'),
                            props: {
                                type: 2
                            },
                            meta: {
                                breadcrumb: false,
                                title: '渠道扣款',
                                keepAlive: true,
                                modules: [14122]
                            }
                        },
                        {
                            path: 'add/:id',
                            name: 'DeductAdd',
                            component: () => import('@/views/finance/channelService/deduct/form'),
                            props: {
                                type: 2
                            },
                            hidden: true,
                            meta: {
                                title: '扣款',
                                activeMenu: '/finance/channelService/deduct/index',
                                modules: [14122]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'DeductDetail',
                            component: () => import('@/views/finance/channelService/deduct/detail'),
                            props: {
                                type: 2
                            },
                            hidden: true,
                            meta: {
                                title: '扣款记录',
                                activeMenu: '/finance/channelService/deduct/index',
                                modules: [14122],
                                isDetail: true
                            }
                        },
                        {
                            path: 'deductDetail/:id',
                            name: 'DeductDetailDetail',
                            component: () => import('@/views/finance/channelService/deduct/deductDetail'),
                            hidden: true,
                            meta: {
                                title: '扣款详情',
                                activeMenu: '/finance/channelService/deduct/index',
                                modules: [14122],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'refund',
                    redirect: '/finance/channelService/refund/index',
                    component: routerView,
                    meta: {
                        title: '渠道提现',
                        modules: [14123]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'RefundIndex',
                            component: () => import('@/views/finance/channelService/refund/index'),
                            props: {
                                type: 3
                            },
                            meta: {
                                breadcrumb: false,
                                title: '渠道提现',
                                keepAlive: true,
                                modules: [14123]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'RefundDetail',
                            component: () => import('@/views/finance/channelService/refund/detail'),
                            props: {
                                type: 3
                            },
                            hidden: true,
                            meta: {
                                title: '提现记录',
                                activeMenu: '/finance/channelService/refund/index',
                                modules: [14123],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'agent',
                    redirect: '/finance/channelService/agent/index',
                    component: routerView,
                    meta: {
                        title: '代理商统计',
                        modules: [14125]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'AgentIndex',
                            component: () => import('@/views/finance/channelService/agent/index'),
                            props: {
                                type: 1
                            },
                            meta: {
                                breadcrumb: false,
                                title: '代理商统计',
                                keepAlive: true,
                                modules: [14125]
                            }
                        },
                        {
                            path: 'list',
                            name: 'AgentList',
                            component: () => import('@/views/finance/channelService/agent/list'),
                            props: {
                                type: 1
                            },
                            hidden: true,
                            meta: {
                                breadcrumb: false,
                                title: '代理商报表',
                                activeMenu: '/finance/channelService/agent/index',
                                keepAlive: true,
                                modules: [14125]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'AgentDetail',
                            component: () => import('@/views/finance/channelService/agent/detail'),
                            props: {
                                type: 1
                            },
                            hidden: true,
                            meta: {
                                title: '代理商统计报表',
                                activeMenu: '/finance/channelService/agent/index',
                                modules: [14125],
                                isDetail: true
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'propertyManage',
            redirect: '/finance/propertyManage/cashManage',
            component: routerView,
            alwaysShow: true,
            meta: {
                title: '物业管理',
                icon: 'spot',
                modules: [14018]
            },
            children: [
                {
                    path: 'cashManage',
                    redirect: '/finance/propertyManage/cashManage/index',
                    component: routerView,
                    meta: {
                        title: '提现管理',
                        modules: [14019]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'CashManageIndex',
                            component: () => import('@/views/finance/propertyManage/cashManage/index'),
                            props: {
                                type: 1
                            },
                            meta: {
                                breadcrumb: false,
                                title: '提现管理',
                                keepAlive: true,
                                modules: [14019]
                            }
                        },
                        {
                            path: 'detail/:tab/:id',
                            name: 'CashManageDetail',
                            component: () => import('@/views/finance/propertyManage/cashManage/detail'),
                            props: {
                                type: 1
                            },
                            hidden: true,
                            meta: {
                                title: '提现详情',
                                activeMenu: '/finance/propertyManage/cashManage/index',
                                modules: [14019],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'incomeManage',
                    redirect: '/finance/propertyManage/incomeManage/index',
                    component: routerView,
                    meta: {
                        title: '收益情况',
                        modules: [14020]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'IncomeManageIndex',
                            component: () => import('@/views/finance/propertyManage/incomeManage/index'),
                            props: {
                                type: 1
                            },
                            meta: {
                                breadcrumb: false,
                                title: '收益情况',
                                keepAlive: true,
                                modules: [14020]
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'IncomeManageDetail',
                            component: () => import('@/views/resources/toolBox/incomeStatistics/detail'),
                            props: {
                                type: 1
                            },
                            hidden: true,
                            meta: {
                                title: '收益详情',
                                activeMenu: '/finance/propertyManage/incomeManage/index',
                                modules: [14020],
                                isDetail: true
                            }
                        }

                    ]
                }
            ]
        },
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/finance/toolBox/index',
            meta: {
                title: '财务工具箱',
                icon: 'spot',
                modules: [14010]
            },
            children: [
                {
                    path: 'index',
                    name: 'toolBox',
                    component: () => import('@/views/finance/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '财务工具箱',
                        modules: [14010]
                    }
                },
                {
                    path: 'offlineSaleContract',
                    name: 'OfflineSaleContract',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/offlineSale/contract'),
                    meta: {
                        title: '线下销售合同报表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14104]
                    }
                },
                {
                    path: 'onlineSaleContract',
                    name: 'OnlineSaleContract',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/onlineSaleContracts'),
                    meta: {
                        title: '线上销售合同报表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14105]
                    }
                },
                //  销售合同跟进--线下详情
                {
                    path: 'salesContractDetail/:id',
                    name: 'ContractFollowDetail',
                    hidden: true,
                    component: () => import('@/views/finance/follow/salesContractFollow/salesContractDetail'),
                    meta: {
                        title: '销售合同跟进详情',
                        activeMenu: '/finance/toolBox/index',
                        keepAlive: true,
                        modules: [14104],
                        isDetail: true
                    }
                },
                //  销售合同跟进--线上详情
                {
                    path: 'onlineSalesContractDetail/:id',
                    name: 'OnlineContractFollowDetail',
                    hidden: true,
                    component: () => import('@/views/finance/follow/salesContractFollow/onlineSalesContractDetail'),
                    meta: {
                        title: '销售合同跟进详情',
                        activeMenu: '/finance/toolBox/index',
                        keepAlive: true,
                        modules: [14105],
                        isDetail: true
                    }
                },
                {
                    path: 'offlineSaleReturn',
                    name: 'OfflineSaleReturn',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/offlineSale/receivedPay'),
                    meta: {
                        title: '线下销售已收账款',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14113]
                    }
                },
                {
                    path: 'offlineSaleUnreceivePay',
                    name: 'OfflineSaleUnreceivePay',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/offlineSale/unreceivePay'),
                    meta: {
                        title: '线下销售应收账款',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14118]
                    }
                },
                {
                    path: 'resourceUnpay',
                    name: 'ResourceUnpay',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/resourcePay/unpaid'),
                    meta: {
                        title: '资源应付账款',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14116]
                    }
                },
                {
                    path: 'resourcePay',
                    name: 'ResourcePay',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/resourcePay/paid'),
                    meta: {
                        title: '资源已付账款',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14114]
                    }
                },
                {
                    path: 'offlineSaleRemind',
                    name: 'OfflineSaleRemind',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/offlineSale/remind'),
                    meta: {
                        title: '合同状态提醒列表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14115]
                    }
                },
                {
                    path: 'apportionment',
                    name: 'Apportionment',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/apportionment'),
                    meta: {
                        title: '分摊表导出',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14106]
                    }
                },
                {
                    path: 'channelApportion',
                    name: 'ChannelApportion',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/channelApportion'),
                    meta: {
                        title: '渠道订单分摊表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14124]
                    }
                },
                {
                    path: 'resourceApportion',
                    name: 'ResourceApportion',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/resourceApportion'),
                    meta: {
                        title: '场租分摊表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14107]
                    }
                },
                {
                    path: 'taskUp',
                    name: 'TaskUp',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/taskUp'),
                    meta: {
                        title: '上刊情况汇总表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14108]
                    }
                },
                {
                    path: 'positionCost',
                    name: 'PositionCost',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/positionCost'),
                    meta: {
                        title: '版位成本统计表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14109]
                    }
                },
                //  收票
                {
                    path: 'collectTickets',
                    name: 'CollectTickets',
                    hidden: true,
                    redirect: '/finance/toolBox/collectTickets/index',
                    component: routerView,
                    meta: {
                        title: '资源合同收票',
                        modules: [14002]
                    },
                    children: [
                        //  收票列表
                        {
                            path: 'index',
                            name: 'CollectTicketsList',
                            component: () => import('@/views/finance/toolBox/collectTickets/index'),
                            meta: {
                                breadcrumb: false,
                                activeMenu: '/finance/toolBox/index',
                                title: '资源合同收票',
                                keepAlive: true,
                                modules: [14002]
                            }
                        },
                        //  新增收票
                        {
                            path: 'collectTicketsForm',
                            name: 'CollectTicketsForm',
                            hidden: true,
                            component: () => import('@/views/finance/toolBox/collectTickets/collectTicketsForm'),
                            meta: {
                                title: '新增收票',
                                activeMenu: '/finance/toolBox/index',
                                keepAlive: true,
                                modules: [14002],
                                isDetail: true
                            }
                        },
                        //  编辑收票
                        {
                            path: 'collectTicketsForm/:id',
                            name: 'EditCollectTicketsForm',
                            hidden: true,
                            component: () => import('@/views/finance/toolBox/collectTickets/collectTicketsForm'),
                            meta: {
                                title: '编辑收票',
                                activeMenu: '/finance/toolBox/index',
                                keepAlive: true,
                                modules: [14002],
                                isDetail: true
                            }
                        },
                        //  收票详情
                        {
                            path: 'collectTicketsDetail/:id',
                            name: 'CollectTicketsDetail',
                            hidden: true,
                            component: () => import('@/views/finance/toolBox/collectTickets/collectTicketsDetail'),
                            meta: {
                                title: '收票详情',
                                activeMenu: '/finance/toolBox/index',
                                keepAlive: true,
                                modules: [14002],
                                isDetail: true
                            }
                        }
                    ]
                },
                // 预算表-财务
                // {
                //     path: 'budgetFinance',
                //     name: 'BudgetFinance',
                //     hidden: true,
                //     component: routerView,
                //     redirect: '/finance/toolBox/budgetFinance/index',
                //     meta: {
                //         title: '预算表',
                //         icon: 'spot',
                //         modules: [14014]
                //     },
                //     children: [
                //         //  预算列表
                //         {
                //             path: 'index',
                //             name: 'BudgetFinanceList',
                //             component: () => import('@/views/finance/toolBox/budgetFinance/index'),
                //             meta: {
                //                 breadcrumb: false,
                //                 activeMenu: '/finance/toolBox/index',
                //                 title: '预算表（财务）',
                //                 keepAlive: true,
                //                 modules: [14014]
                //             }
                //         },
                //         //  新增预算
                //         {
                //             path: 'add',
                //             name: 'BudgetFinanceAdd',
                //             hidden: true,
                //             component: () => import('@/views/finance/toolBox/budgetFinance/budgetForm'),
                //             meta: {
                //                 activeMenu: '/finance/toolBox/index',
                //                 title: '新增预算表',
                //                 keepAlive: true,
                //                 isDetail: true,
                //                 modules: [14014]
                //             }
                //         },
                //         //  编辑预算
                //         {
                //             path: 'edit',
                //             name: 'BudgetFinanceEdit',
                //             hidden: true,
                //             component: () => import('@/views/finance/toolBox/budgetFinance/budgetForm'),
                //             meta: {
                //                 activeMenu: '/finance/toolBox/index',
                //                 title: '编辑预算表',
                //                 keepAlive: true,
                //                 isDetail: true,
                //                 modules: [14014]
                //             }
                //         }
                //     ]
                // },
                // 预算表-管理
                // {
                //     path: 'budgetAdmin',
                //     component: routerView,
                //     redirect: '/finance/toolBox/budgetAdmin/index',
                //     hidden: true,
                //     meta: {
                //         title: '预算表',
                //         icon: 'spot',
                //         modules: [14015]
                //     },
                //     children: [
                //         //  预算列表
                //         {
                //             path: 'index',
                //             name: 'BudgetAdminList',
                //             component: () => import('@/views/finance/toolBox/budgetAdmin/index'),
                //             meta: {
                //                 breadcrumb: false,
                //                 activeMenu: '/finance/toolBox/index',
                //                 title: '预算表（管理）',
                //                 keepAlive: true,
                //                 modules: [14015]
                //             }
                //         }
                //     ]
                // },
                {
                    path: 'invoiceCancel',
                    name: 'invoiceCancel',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/invoiceCancel'),
                    meta: {
                        title: '发票作废',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14017]
                    }
                },
                {
                    path: 'invoiceStatistics',
                    name: 'InvoiceStatistics',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/invoiceStatistics'),
                    meta: {
                        title: '开票统计',
                        activeMenu: '/finance/toolBox/index',
                        modules: [14117]
                    }
                },
                {
                    path: 'inquireStatistics',
                    name: 'InquireStatistics',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/inquireStatistics'),
                    meta: {
                        title: '线上查款统计',
                        activeMenu: '/finance/toolBox/index',
                        modules: [14119]
                    }
                },
                {
                    path: 'onlineChargeStatistics',
                    hidden: true,
                    component: () => import('@/views/finance/toolBox/onlineChargeStatistics'),
                    props: {
                        isFinance: true
                    },
                    meta: {
                        title: '线上充值情况表',
                        keepAlive: true,
                        activeMenu: '/finance/toolBox/index',
                        modules: [14127]
                    }
                }
            ]
        }
    ]
};
